import { Bug, Github, Lock, Mail } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { BugReportDialog } from "@/components/BugReportDialog";
import { FOOTER_TEXT } from "@/lib/branding";

const GITHUB_URL = "https://github.com/ghostinator/catalogkit";

/** App footer: attribution, links, contact, bug report, and a privacy badge. */
export function Footer(): JSX.Element {
  const [bugOpen, setBugOpen] = useState(false);
  return (
    <footer className="border-t px-6 py-4 text-sm text-muted-foreground">
      <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
        <div className="flex flex-wrap items-center gap-4">
          <span className="font-medium text-foreground">CatalogKit</span>
          <a
            href={GITHUB_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 hover:text-foreground"
          >
            <Github className="h-4 w-4" />
            GitHub
          </a>
          <Link to="/privacy" className="hover:text-foreground">
            Privacy
          </Link>
          <Link to="/transparency" className="hover:text-foreground">
            Transparency
          </Link>
          <Link to="/contact" className="inline-flex items-center gap-1 hover:text-foreground">
            <Mail className="h-4 w-4" />
            Contact
          </Link>
          <button
            type="button"
            onClick={() => setBugOpen(true)}
            className="inline-flex items-center gap-1 hover:text-foreground"
          >
            <Bug className="h-4 w-4" />
            Report an issue
          </button>
        </div>
        <Link
          to="/privacy-inspector"
          title="Open the Privacy Inspector"
          className="inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/5 px-3 py-1 text-primary transition-colors hover:bg-primary/10"
        >
          <Lock className="h-3.5 w-3.5" />
          100% local, verifiable
        </Link>
      </div>
      <p className="mt-3 text-center text-xs">{FOOTER_TEXT}</p>
      <BugReportDialog open={bugOpen} onOpenChange={setBugOpen} />
    </footer>
  );
}
